import dependencies from "../authentication/dependencies";
import { formatApiError } from "../constants/apiErrorMessages";
import { NEW_BASE_URL } from "../config";
import { createBackendRequest } from "../mappers/backendMappers";
const { baseUrl, generalHeader } = dependencies;

export const subscribeApiProductToApplicationQuery = async (
  csrfToken,
  data,
  userId
) => {
  // Determine if it's subscribe or unsubscribe
  const isSubscribe = data.type === "subscribe";
  const endpoint = isSubscribe
    ? "/AppSubscription/create"
    : "/AppSubscription/delete";

  // Create request body for new backend API
  const requestBody = createBackendRequest(
    {
      ApplicationId: data.application,
      ProductId: data.product,
    },
    userId
  );

  const response = await fetch(`${NEW_BASE_URL}${endpoint}`, {
    method: "POST",
    headers: {
      ...generalHeader(csrfToken),
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(requestBody),
  });

  const result = await response.json();

  // Check for exception in response (API returns 200 even with errors)
  if (result.exception) {
    // Extract error message from various formats
    let errorMessage = "Something went wrong. Please try again";

    if (typeof result.exception === "string") {
      errorMessage = result.exception;
    } else if (result.exception && typeof result.exception === "object") {
      errorMessage = formatApiError(result.exception);
    }

    throw new Error(errorMessage);
  }

  return result;
};
